export const parseYearFromDate = (value) => {
  if (!value) return null;
  const year = Number(String(value).slice(0, 4));
  return Number.isFinite(year) ? year : null;
};

export const getYearsInVigenciaRange = (dtIni, dtFim) => {
  const startYear = parseYearFromDate(dtIni);
  const endYear = parseYearFromDate(dtFim);
  if (startYear == null || endYear == null || startYear > endYear) return [];
  const years = [];
  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }
  return years;
};

export const isVigenciaDatasInvalidas = (dtIni, dtFim) => {
  if (!dtIni || !dtFim) return false;

  const startDate = new Date(`${dtIni}T00:00:00`);
  const endDate = new Date(`${dtFim}T00:00:00`);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return true;

  return startDate > endDate;
};

export const getAnoVigenteDateRange = () => {
  const year = new Date().getFullYear();
  return {
    dtIni: `${year}-01-01`,
    dtFim: `${year}-12-31`,
  };
};

export const buildResumoOrcamentoAnoVigente = ({
  listaDotacoes = [],
  valoresLimites = [],
} = {}) => {
  const { dtIni, dtFim } = getAnoVigenteDateRange();
  return buildResumoOrcamentoPorAno({
    dtIni,
    dtFim,
    listaDotacoes,
    valoresLimites,
  });
};

export const buildResumoOrcamentoPorAno = ({
  dtIni,
  dtFim,
  listaDotacoes = [],
  valoresLimites = [],
}) => {
  const years = getYearsInVigenciaRange(dtIni, dtFim);
  if (!years.length) return [];

  return years.map((year) => {
    const dotacoesAno = listaDotacoes.filter(
      ({ orcDot_data }) => parseYearFromDate(orcDot_data) === year,
    );
    const limitesAno = valoresLimites.filter(
      ({ mes }) => parseYearFromDate(mes) === year,
    );
    const somaDotacoes = dotacoesAno.reduce(
      (acc, cur) => Number(acc) + Number(cur.orcDot_valor || 0),
      0,
    );
    const valorDisponivel = limitesAno.reduce(
      (acc, cur) => Number(acc) + Number(cur.disponivel || 0),
      0,
    );

    return {
      year,
      somaDotacoes,
      valorDisponivel,
      jaAlocados: somaDotacoes - valorDisponivel,
    };
  });
};
